import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SecondaryGhostLink } from '@bibliocommons/base-links';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';

import './StaffTakeoverMessage.scss';

const StaffTakeoverMessage = ({ name }) => (
  <div className="cp-staff-takeover-message">
    <div className="wrapper">
      <p className="message">
        <FormattedHTMLMessage id="staffTakeoverMessage" values={{ name }} />
      </p>

      <SecondaryGhostLink className="reset-button" dataKey="reset-staff-session-link" href="/user/reset_admin_session">
        <FormattedMessage id="resetStaffSessionLink" />
      </SecondaryGhostLink>
    </div>
  </div>
);

StaffTakeoverMessage.propTypes = {
  name: PropTypes.string.isRequired
};

export default StaffTakeoverMessage;
